var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success"},[_c('h2',[_vm._v("You found a solution!")]),_c('button',{on:{"click":_vm.clear}},[_vm._v("Play Again")])])}
var staticRenderFns = []

export { render, staticRenderFns }